export enum CarStatusFilter {
  ACTIVE = 'active',
  ENDED = 'ended',
}
